module.exports = "https://qiaozuji-flms-public.cdn.qiaozuji.com/resource/h5/img/down_load_app_btn.png";